import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const saveQurbaniStep = createAsyncThunk(
    'qurbani/saveStep',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/save-step', payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to save step');
        }
    },
);


export const fetchQurbaniProducts = createAsyncThunk(
    'qurbani/fetchProducts',
    async (farmId = 0, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/products/', {
                params: {
                    product_type: 'qurbani',
                    order_sub_type_id: farmId || 0,
                    visibility_info: 0,
                },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to fetch products');
        }
    },
);


export const fetchQurbaniInformation = createAsyncThunk(
    'qurbani/fetchInformation',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/qurbani/information');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to fetch qurbani information');
        }
    },
);

export const fetchQurbaniCart = createAsyncThunk(
    'qurbani/fetchCart',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/qurbani/cart');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to fetch cart');
        }
    },
);

export const emptyQurbaniCart = createAsyncThunk(
    'qurbani/emptyCart',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/empty');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to empty qurbani cart');
        }
    },
);

export const placeQurbaniOrder = createAsyncThunk(
    'qurbani/placeOrder',
    async (extraPayload = {}, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const userId = state.auth?.userInfo?.user_id;
            const platformType = localStorage.getItem('isMobileApp') === 'true' ? 'mobile' : 'web';
            const payload = {
                action: 'place-order',
                order_type: 'qurbani',
                user_id: String(userId || ''),
                platform_type: platformType,
                ...extraPayload
            };
            const { data } = await axiosInstance.post('/checkout/place-order', payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to place order');
        }
    },
);

export const addQurbaniCartItem = createAsyncThunk(
    'qurbani/addCartItem',
    async ({ product_id, product_quantity }, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/add', {
                product_id,
                product_quantity,
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to add to qurbani cart');
        }
    },
);

export const updateQurbaniCartItem = createAsyncThunk(
    'qurbani/updateCartItem',
    async ({ product_id, product_quantity, qty_step_2 = 0 }, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/update', {
                product_id,
                product_quantity,
                qty_step_2,
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to update qurbani cart');
        }
    },
);

export const fetchQurbaniScheduleSlots = createAsyncThunk(
    'qurbani/fetchScheduleSlots',
    async (year, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/qurbani/schedule-slots', {
                params: { year: year || new Date().getFullYear() },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to fetch schedule slots');
        }
    },
);

export const adminQurbaniPriceAdjustment = createAsyncThunk(
    'qurbani/adminPriceAdjustment',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/admin/price-adjustment', payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.response?.data?.detail || 'Failed to submit price adjustment');
        }
    },
);